import { WarningRegular } from "@/pages/taskpane/components/icons/IconCustom";
import Button from "@/pages/taskpane/components/ui/Button";
import { useTranslation } from "react-i18next";
import React from "react";
import { PreSelectedResourceInfo } from "@/pages/taskpane/shared/types/preSelectedResource";
import { usePreSelectedResourceStore } from "@/pages/taskpane/shared/stores/preSelectedResourceStore";
import { useAppConfigStore } from "@/pages/taskpane/shared/stores";

type Props = {
  notifyInfo?: PreSelectedResourceInfo;
};

const RemovedResource = ({ notifyInfo }: Props) => {
  const { removeItem } = usePreSelectedResourceStore();
  const { t } = useTranslation();
  const { parameters } = useAppConfigStore();

  const onRemoveItem = () => {
    if (notifyInfo) {
      removeItem(notifyInfo);
    }
  };

  // Only pass daysReserved if the message contains the placeholder
  const message = notifyInfo?.message ?? "";
  const translationParams = message.includes("{{daysReserved}}") ? { daysReserved: parameters.daysReserved } : {};

  return (
    <div className="flex flex-col gap-6">
      <div className="flex gap-2">
        <div>
          <WarningRegular />
        </div>
        <div className="flex flex-col gap-2">
          <span className="text-sm font-medium text-gray-900 dark:text-white">
            {t("Your selected resource {{resourceName}} was removed from the meeting due to the following conflict:", {
              resourceName: notifyInfo?.resources.map((item) => item.name).join(", "),
            })}
          </span>
          <span className="text-xs font-normal text-gray-900 dark:text-white">{t(message, translationParams)}</span>
          <div className="flex justify-start mt-4">
            <Button
              className="bg-primaryBlue text-white w-[50%] h-[32px] dark:bg-brightBlue dark:text-black text-xs"
              label={t("OK")}
              onClick={onRemoveItem}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemovedResource;
